module.exports = __webpack_public_path__ + "trust-marks-seobook.4df629.png";